export const POPUP_TYPE = {
    CLOSE: 'CLOSE',
    HOSPITAL_BED: 'HOSPITAL_BED',
    SYMPTOM: 'SYMPTOM',
    TUBE: 'TUBE',
    LANG: 'LANG',
    SERVED_ITEM: 'SERVED_ITEM',
    ALL_DAY_EXPECTED_START_TIME: 'ALL_DAY_EXPECTED_START_TIME',
    PART_TIME_TIME_SLOT_LIST: 'PART_TIME_TIME_SLOT_LIST',
};
export const ALL_DAY_EXPECTED_START_TIME_POPUP_TOTAL_PROGRESS = 2;
